"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TODAY = void 0;
exports.TODAY = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        const date = new Date();
        date.setUTCHours(0, 0, 0);
        const iso8601date = date.toISOString().slice(0, 10);
        return {
            error: null,
            result: iso8601date,
        };
    },
};
//# sourceMappingURL=today.js.map